export default "/images/vendor/@coreui/icons/svg/flag/cif-co.svg?3b1c50b45c293af7bb9f17cc8eedbf74";